import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import Search from '@/components/SearchV3/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import Pagination from '@/components/Pagination/index.vue';
import { getDmUsage } from '@/api/dashboard/project.js';
import { format, subDays } from 'date-fns';
import { downloadWithNewWindow } from '@/common/download';
import { v2Host } from '@/config/host';
import qs from 'qs';
import { parseTime } from '@/filters/index';
import { cookRequestParams } from '@/common/request';
import tableMixin from './table-mixin';

var dayTime = 1000 * 60 * 60 * 24;

var defaultQuery = {
  page: 1,
  page_size: 50,
  time: [format(subDays(new Date() - dayTime * 30, 1), 'YYYY-MM-DD'), format(subDays(new Date(), 1), 'YYYY-MM-DD')],
  push_download_time: [],
  adv_ids: [],
  adv_id: '',
  account_ids: '',
  adv_search_type: 'adv_name',
  project_name: '',
  project_ids: '',
  biz_scenario: '',
  DemandType: '',
  demand_ids: '',
  template_name: '',
  template_ids: '',
  is_pushed: '',
  export: 0
};

var bizScenarioOptions = [{
  label: '付费制作',
  value: 1
}, {
  label: '创意优化',
  value: 2
}, {
  label: '模板制作',
  value: 3
}, {
  label: '非仓库制作',
  value: 4
}];

export default {
  mixins: [searchMixin, tableMixin],

  components: {
    Search: Search,
    TableList: TableList,
    Pagination: Pagination
  },
  data: function data() {
    return {
      query: _extends({}, defaultQuery),

      list: [],
      listLoading: false,

      tableConfig: {
        'row-key': '_id'
      },

      pagination: {
        total: 0
      }
    };
  },


  computed: {
    formItemList: function formItemList() {
      var list = {
        time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'time',
          class: 'date-picker',
          params: {
            clearable: false,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '创建开始时间',
            endPlaceholder: '创建结束时间',
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() > Date.now();
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        },
        push_download_time: {
          type: 'date-picker',
          subtype: 'daterange',
          prop: 'push_download_time',
          class: 'date-picker',
          params: {
            clearable: true,
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
            startPlaceholder: '推送下载开始时间',
            endPlaceholder: '推送下载结束时间',
            pickerOptions: {
              disabledDate: function disabledDate(time) {
                return time.getTime() > Date.now();
              },

              shortcuts: [{
                text: '最近三天',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: this.$t('form.pastWeek'),
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近半个月',
                onClick: function onClick(picker) {
                  var end = new Date();
                  var start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
                  picker.$emit('pick', [start, end]);
                }
              }]
            }
          }
        },
        adv_search_type: {
          type: 'select',
          prop: 'adv_search_type',
          params: {
            options: [{
              label: '广告主名称',
              value: 'adv_name'
            }, {
              label: '广告主ID',
              value: 'adv_id'
            }]
          }
        },
        adv_ids: {
          prop: 'adv_ids',
          type: 'business',
          subtype: 'advertiser-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select'
          }
        },
        adv_id: {
          type: 'input',
          prop: 'adv_id',
          params: {
            clearable: true,
            placeholder: '请输入广告主ID'
          }
        },
        account_ids: {
          prop: 'account_ids',
          type: 'business',
          subtype: 'account-mtg-selector',
          params: {
            multiple: true,
            filterable: true,
            collapseTags: true,
            class: 'search-filter-select',
            placeholder: '推送mtg主账号'
          }
        },
        template_name: {
          type: 'input',
          prop: 'template_name',
          params: {
            clearable: true,
            placeholder: '请输入创意方向名称'
          }
        },
        template_ids: {
          type: 'input',
          prop: 'template_ids',
          params: {
            clearable: true,
            placeholder: '请输入创意方向id'
          }
        },
        project_name: {
          type: 'input',
          prop: 'project_name',
          params: {
            clearable: true,
            placeholder: '请输入项目名称'
          }
        },
        project_ids: {
          type: 'input',
          prop: 'project_ids',
          params: {
            clearable: true,
            placeholder: '请输入项目id'
          }
        },
        DemandType: {
          type: 'input',
          prop: 'DemandType',
          params: {
            clearable: true,
            placeholder: '请输入需求名称'
          }
        },
        demand_ids: {
          type: 'input',
          prop: 'demand_ids',
          params: {
            clearable: true,
            placeholder: '请输入需求id'
          }
        },
        biz_scenario: {
          type: 'select',
          prop: 'biz_scenario',
          params: {
            clearable: true,
            placeholder: '需求类型',
            options: bizScenarioOptions
          }
        },
        is_pushed: {
          type: 'select',
          prop: 'is_pushed',
          params: {
            clearable: true,
            placeholder: '是否有推送/下载',
            options: this.pushAddDownloadList
          }
        }
        // 广告主/id
      };if (this.query.adv_search_type === 'adv_name') {
        delete list.adv_id;
      } else {
        delete list.adv_ids;
      }
      return list;
    },
    tableColumnConfig: function tableColumnConfig() {
      var tableList = [{
        label: '广告主id',
        prop: 'adv_id'
      }, {
        label: '广告主pt账号名',
        prop: 'adv_name'
      }, {
        label: '推送mtg主账号',
        prop: 'account_names'
      }, {
        label: '登陆天数',
        prop: 'login_days'
      }, {
        label: '创意方向id',
        prop: 'template_id'
      }, {
        label: '创意方向名称',
        prop: 'template_name'
      }, {
        label: '包名',
        prop: 'pkg_name'
      }, {
        label: '产品名称',
        prop: 'app_name'
      }, {
        label: '创意方向创建时间',
        prop: 'template_create_time'
      }, {
        label: '项目id',
        prop: 'project_id'
      }, {
        label: '项目名称',
        prop: 'project_name'
      }, {
        label: '项目创建时间',
        prop: 'created_time',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return parseTime(row.created_time, '{y}-{m}-{d}');
          }
        }
      }, {
        label: '项目删除状态',
        prop: 'deleted',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return row.deleted === 1 ? '已删除' : '未删除';
          }
        }
      }, {
        label: '需求id',
        prop: 'demand_id'
      }, {
        label: '需求名称',
        prop: 'demand_name'
      }, {
        label: '需求类型',
        prop: 'biz_scenario',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            var temp = bizScenarioOptions.find(function (item) {
              return item.value === row.biz_scenario;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '操作',
        prop: 'preview_url',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            if (!row.has_preview) return '-';
            return '<a href="' + row.preview_url + '?preview=true" target="_blank">\u9884\u89C8</a>';
          }
        }
      }, {
        label: '是否推送下载',
        prop: 'is_pushed',
        params: {
          innerHTML: function innerHTML(_ref5) {
            var row = _ref5.row;

            return row.is_pushed ? '是' : '否';
          }
        }
      }, {
        label: '下载/推送次数（总）',
        prop: 'push_cnt'
      }, {
        label: 'Mintegral',
        prop: 'mintegral',
        params: {
          innerHTML: function innerHTML(_ref6) {
            var row = _ref6.row;

            return row.channels_push_cnt.Mintegral;
          }
        }
      }, {
        label: 'Adcolony',
        prop: 'adcolony',
        params: {
          innerHTML: function innerHTML(_ref7) {
            var row = _ref7.row;

            return row.channels_push_cnt.Adcolony;
          }
        }
      }, {
        label: 'applovin',
        prop: 'applovin',
        params: {
          innerHTML: function innerHTML(_ref8) {
            var row = _ref8.row;

            return row.channels_push_cnt.applovin;
          }
        }
      }, {
        label: 'Chartboost',
        prop: 'Chartboost',
        params: {
          innerHTML: function innerHTML(_ref9) {
            var row = _ref9.row;

            return row.channels_push_cnt.Chartboost;
          }
        }
      }, {
        label: 'facebook',
        prop: 'facebook',
        params: {
          innerHTML: function innerHTML(_ref10) {
            var row = _ref10.row;

            return row.channels_push_cnt.facebook;
          }
        }
      }, {
        label: 'google',
        prop: 'google',
        params: {
          innerHTML: function innerHTML(_ref11) {
            var row = _ref11.row;

            return row.channels_push_cnt.google;
          }
        }
      }, {
        label: 'imobile',
        prop: 'imobile',
        params: {
          innerHTML: function innerHTML(_ref12) {
            var row = _ref12.row;

            return row.channels_push_cnt.imobile;
          }
        }
      }, {
        label: 'Ironsource',
        prop: 'Ironsource',
        params: {
          innerHTML: function innerHTML(_ref13) {
            var row = _ref13.row;

            return row.channels_push_cnt.Ironsource;
          }
        }
      }, {
        label: 'Kwai',
        prop: 'Kwai',
        params: {
          innerHTML: function innerHTML(_ref14) {
            var row = _ref14.row;

            return row.channels_push_cnt.Kwai;
          }
        }
      }, {
        label: 'liftoff',
        prop: 'liftoff',
        params: {
          innerHTML: function innerHTML(_ref15) {
            var row = _ref15.row;

            return row.channels_push_cnt.liftoff;
          }
        }
      }, {
        label: 'myTarget',
        prop: 'myTarget',
        params: {
          innerHTML: function innerHTML(_ref16) {
            var row = _ref16.row;

            return row.channels_push_cnt.myTarget;
          }
        }
      }, {
        label: 'other',
        prop: 'other',
        params: {
          innerHTML: function innerHTML(_ref17) {
            var row = _ref17.row;

            return row.channels_push_cnt.other;
          }
        }
      }, {
        label: 'Pangle',
        prop: 'Pangle',
        params: {
          innerHTML: function innerHTML(_ref18) {
            var row = _ref18.row;

            return row.channels_push_cnt.Pangle;
          }
        }
      }, {
        label: 'Tapjoy',
        prop: 'Tapjoy',
        params: {
          innerHTML: function innerHTML(_ref19) {
            var row = _ref19.row;

            return row.channels_push_cnt.Tapjoy;
          }
        }
      }, {
        label: 'unity',
        prop: 'unity',
        params: {
          innerHTML: function innerHTML(_ref20) {
            var row = _ref20.row;

            return row.channels_push_cnt.unity;
          }
        }
      }, {
        label: 'vungle',
        prop: 'vungle',
        params: {
          innerHTML: function innerHTML(_ref21) {
            var row = _ref21.row;

            return row.channels_push_cnt.vungle;
          }
        }
      }, {
        label: 'tiktok',
        prop: 'tiktok',
        params: {
          innerHTML: function innerHTML(_ref22) {
            var row = _ref22.row;

            return row.channels_push_cnt.tiktok;
          }
        }
      }, {
        label: 'smadex',
        prop: 'smadex',
        params: {
          innerHTML: function innerHTML(_ref23) {
            var row = _ref23.row;

            return row.channels_push_cnt.smadex;
          }
        }
      }, {
        label: '广点通',
        prop: '广点通',
        params: {
          innerHTML: function innerHTML(_ref24) {
            var row = _ref24.row;

            return row.channels_push_cnt['广点通'];
          }
        }
      }, {
        label: '快手',
        prop: '快手',
        params: {
          innerHTML: function innerHTML(_ref25) {
            var row = _ref25.row;

            return row.channels_push_cnt['快手'];
          }
        }
      }, {
        label: '腾讯AMS',
        prop: '腾讯AMS',
        params: {
          innerHTML: function innerHTML(_ref26) {
            var row = _ref26.row;

            return row.channels_push_cnt['腾讯AMS'];
          }
        }
      }, {
        label: '头条',
        prop: '头条',
        params: {
          innerHTML: function innerHTML(_ref27) {
            var row = _ref27.row;

            return row.channels_push_cnt['头条'];
          }
        }
      }];

      return tableList;
    }
  },

  watch: {
    $route: function $route(to, from) {
      if (_.isEmpty(to.query)) {
        this.query = _extends({}, defaultQuery);
      }
      this.dispatch();
    }
  },

  mounted: function mounted() {
    this.dispatch();
  },


  methods: {
    exportSheet: function exportSheet() {
      var params = _extends({}, this.getParamsData(this.query), {
        export: 1
      });
      downloadWithNewWindow(v2Host + '/dashboard/project/dm-usages?' + qs.stringify(_extends({}, cookRequestParams(params))));
    },
    handleSortChange: function handleSortChange(_ref28) {
      var column = _ref28.column,
          prop = _ref28.prop,
          order = _ref28.order;

      if (order) {
        this.query.order = (order === 'descending' ? '-' : '') + prop;
      } else {
        this.query.order = '';
      }
      this.$router.push({
        query: this.query
      });
    },
    dispatch: function dispatch() {
      this.getMaterialReport();
    },
    getMaterialReport: function getMaterialReport(params) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, sum, list;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.prev = 1;
                _context.next = 4;
                return getDmUsage(_this.getParamsData(params));

              case 4:
                res = _context.sent;
                sum = _.get(res, 'data.data.sum', []);
                list = sum.concat(_.get(res, 'data.data.list') || []);

                _this.list = list;
                _this.pagination.total = _.get(res, 'data.data.total') || 0;
                _this.listLoading = false;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](1);

                _this.listLoading = false;

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 12]]);
      }))();
    },
    getParamsData: function getParamsData(params) {
      var innerParams = _.omit(_.cloneDeep(params || this.query), ['adv_search_type', 'adv_id']);
      if (!_.isEmpty(innerParams.push_download_time)) {
        innerParams.download_push_start_date = innerParams.push_download_time[0];
        innerParams.download_push_end_date = innerParams.push_download_time[1];
        innerParams = _.omit(innerParams, ['push_download_time']);
      }
      innerParams.adv_ids = this.query.adv_search_type === 'adv_name' ? this.query.adv_ids : [this.query.adv_id];
      return innerParams;
    },
    handleColumnFilterChange: function handleColumnFilterChange() {
      this.query.page = 1;
      this.handleSearch(this.query);
    },
    resetSearch: function resetSearch() {
      this.handleResetSearch();
    }
  }
};